import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { useDropzone } from "react-dropzone";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { updateMeta } from "../../store/actions/metaAction";
import { handleImageLink } from "../../helpers/Function";

const WorkShow = ({ match }) => {
	const {
		params: { workID },
	} = match;

	const auth = useSelector(state => state.auth.user);
	const [loading, setLoading] = useState(true);
	const [title, setTitle] = useState("");
	const [url, setUrl] = useState("");
	const [description, setDescription] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [files, setFiles] = useState([]);
	const [imageArray, setImageArray] = useState([]);
	const [typographyImageArray, setTypographyImageArray] = useState([]);
	/// name - date -category - videoUrl
	const [customerName, setCustomerName] = useState("");
	const [workDate, setWorkDate] = useState("");
	const [workCategory, setWorkCategory] = useState("");
	const [videoUrl, setVideoUrl] = useState("");

	const [infoTitle, setInfoTitle] = useState("");
	const [infoText, setInfoText] = useState("");
	const [informations, setInformations] = useState([]);
	// eslint-disable-next-line no-unused-vars
	const [categories, setCategories] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState(0);
	const [pageTitle, setPageTitle] = useState("");
	const [pageUrl, setPageUrl] = useState("");
	const [pageDescrition, setPageDescrition] = useState("");
	const [pageKeyWords, setPageKeyWords] = useState("");
	const dispatch = useDispatch();

	let editor = null;

	const { getRootProps, getInputProps } = useDropzone({
		accept: "image/*",
		onDrop: acceptedFiles => {
			setFiles(
				acceptedFiles.map(file =>
					Object.assign(file, {
						preview: URL.createObjectURL(file),
					})
				)
			);
		},
	});

	const thumbs = files.map(file => (
		<div className="thumb" key={file.name}>
			<div className="thumbInner">
				<img src={file.preview} className="img" alt="" />
			</div>
		</div>
	));

	useEffect(
		() => () => {
			files.forEach(file => URL.revokeObjectURL(file.preview));
		},
		[files]
	);

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل العمل",
				breadcrumb: "الأعمال",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/${workID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setTitle(response.data.data.data.title);
				setUrl(response.data.data.data.url);
				setDescription(response.data.data.data.descriptio ?? "");
				setPicture(handleImageLink(response.data.data.data.main_image));
				setInformations(response.data.data.data.inforomation);
				setImageArray(response.data.data.data.slider);

				setTypographyImageArray(
					response.data.data.data.typographyImageArray ?? []
				);

				setCustomerName(response.data.data.data.customerName);
				setWorkDate(response.data.data.data.workDate);
				setWorkCategory(response.data.data.data.workCategory);

				setVideoUrl(response.data.data.data.videoUrl);

				setSelectedCategory(response.data.data.category.id);
				setPageTitle(response.data.data.data.pageTitle);
				setPageUrl(response.data.data.data.pageUrl);
				setPageDescrition(response.data.data.data.pageDescrition);
				setPageKeyWords(response.data.data.data.pageKeyWords);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
		axios
			.get(`${process.env.REACT_APP_API_URL}/type_categories/our_works`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setCategories(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handlePicture = e => {
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
	};

	const pushToInformation = e => {
		e.preventDefault();
		if (infoTitle === "" || infoText === "") {
			toast.error("برجاء تعبئة الحقول المطلوبة!");
			return;
		}
		const data = { title: infoTitle, value: infoText };
		informations.push(data);
		setInformations(informations);
		setInfoTitle("");
		setInfoText("");
	};

	const handleDeleteInfo = (event, information) => {
		event.preventDefault();
		const arr = informations.filter(function (item) {
			return item.title !== information.title;
		});
		setInformations(arr);
	};

	const handleSubmit = e => {
		e.preventDefault();
		const pictureInput = document.querySelector("#picture");
		if (pictureInput.files[0]) {
			setLoading(true);
			const data = new FormData();
			data.append("file", pictureInput.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					const data = {
						title: title,
						url: url,
						descriptio: description,
						main_image: response.data.data.name,
						inforomation: informations,
						slider: imageArray,
						typographyImageArray,
						pageTitle: pageTitle,
						pageUrl: pageUrl,
						pageDescrition: pageDescrition,
						pageKeyWords: pageKeyWords,
						customerName,
						workDate,
						workCategory,
						videoUrl,
					};
					axios
						.put(
							`${process.env.REACT_APP_API_URL}/posts/${workID}`,
							{
								category_id: selectedCategory,
								admin_id: auth.data.id,
								data: data,
							},
							{
								headers: {
									Authorization: `Bearer ${cookie.get("token")}`,
									Accept: "application/json",
								},
							}
						)
						.then(function (response) {
							toast.success("تم تحديث بيانات العمل بنجاح!");
							setLoading(false);
						})
						.catch(function (error) {
							toast.error("خطأ، برجاء المحاولة مره اخرى!");
							setLoading(false);
						});
				})
				.catch(error => {
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		}
		const data = {
			title: title,
			url: url,
			descriptio: description,
			main_image: picture,
			inforomation: informations,
			slider: imageArray,
			typographyImageArray,
			pageTitle: pageTitle,
			pageUrl: pageUrl,
			pageDescrition: pageDescrition,
			pageKeyWords: pageKeyWords,
			customerName,
			workDate,
			workCategory,
			videoUrl,
		};
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/posts/${workID}`,
				{
					category_id: selectedCategory,
					admin_id: auth.data.id,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				toast.success("تم تحديث بيانات العمل بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	const handleImageUpload = e => {
		e.preventDefault();
		for (let i = 0; i < files.length; i++) {
			const formData = new FormData();
			formData.append(`file`, files[i]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(function (responseImage) {
					imageArray.push(responseImage.data.data.name);
					setImageArray(imageArray);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
		toast.success("تم رفع الصور بنجاح!");
	};

	const handleTypographyImageUpload = e => {
		e.preventDefault();
		for (let i = 0; i < files.length; i++) {
			const formData = new FormData();
			formData.append(`file`, files[i]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(function (responseImage) {
					typographyImageArray.push(responseImage.data.data.name);
					setTypographyImageArray(typographyImageArray);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
		toast.success("تم رفع الصور بنجاح!");
	};

	const deleteImage = (event, img) => {
		event.preventDefault();
		const arr = imageArray.filter(item => {
			return item !== img;
		});
		setImageArray(arr);
	};

	const deleteTypoghraphyImage = (event, img) => {
		event.preventDefault();
		const arr = typographyImageArray.filter(item => {
			return item !== img;
		});
		setTypographyImageArray(arr);
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="title">التصنيف</label>
									<select
										id="category"
										onChange={e => setSelectedCategory(e.target.value)}
										value={selectedCategory}
									>
										<option value="0">اختر التصنيف</option>
										{/* {categories.map(
											category => console.log(category)
											// <option value={category.id} key={category.id}>
											// 	{category.title}
											// </option>
										)} */}
									</select>
								</div>
								<div className="row">
									<div className="col-md-6">
										<div className="form-item">
											<label htmlFor="title">العنوان</label>
											<input
												type="text"
												id="title"
												required
												value={title}
												onChange={e => setTitle(e.target.value)}
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-item">
											<label htmlFor="url">رابط المعاينة</label>
											<input
												type="text"
												id="url"
												value={url}
												onChange={e => setUrl(e.target.value)}
											/>
										</div>
									</div>
								</div>
								<div className="form-item">
									<label htmlFor="description">الوصف</label>
									<CKEditor
										data={description}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											// eslint-disable-next-line no-self-assign
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setDescription(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="videoUrl">رابط الفيديو</label>
									<input
										type="text"
										id="videoUrl"
										value={videoUrl}
										onChange={e => setVideoUrl(e.target.value)}
									/>
								</div>
								<div className="dropzoneContainer">
									<div {...getRootProps({ className: "dropzone" })}>
										<input {...getInputProps()} />
										<p>اضغط هنا لرفع الصور</p>
									</div>
									<aside className="thumbsContainer">{thumbs}</aside>
									<button className="bt bt-success" onClick={handleImageUpload}>
										رفع الصور
									</button>
								</div>
								<div className="row">
									{imageArray.map(img => (
										<div className="col-md-2" key={img}>
											<div className="image-preview">
												<img
													src={`${process.env.REACT_APP_MAIN_URL}${img}`}
													alt={img}
													className="imgList"
												/>
												<button
													onClick={e => deleteImage(e, img)}
													aria-label="حذف الصورة"
												>
													<i className="fas fa-trash"></i>
												</button>
											</div>
										</div>
									))}
								</div>
								<label className="my-4">صور التايبوجرافي</label>
								<div className="dropzoneContainer">
									<div {...getRootProps({ className: "dropzone" })}>
										<input {...getInputProps()} />
										<p>اضغط هنا لرفع الصور</p>
									</div>
									<aside className="thumbsContainer">{thumbs}</aside>
									<button
										onClick={handleTypographyImageUpload}
										className="bt bt-success"
									>
										رفع الصور
									</button>
								</div>

								<div className="row">
									{typographyImageArray.map(img => (
										<div className="col-md-2" key={img}>
											<div className="image-preview">
												<img
													src={`${process.env.REACT_APP_MAIN_URL}${img}`}
													alt={img}
													className="imgList"
												/>
												<button
													onClick={e => deleteTypoghraphyImage(e, img)}
													aria-label="حذف الصورة"
												>
													<i className="fas fa-trash"></i>
												</button>
											</div>
										</div>
									))}
								</div>

								<br />
								<hr />
								<br />
								<div className="form-item">
									<label htmlFor="question">عنوان المعلومة</label>
									<input
										type="text"
										id="question"
										value={infoTitle}
										onChange={e => setInfoTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="answer">نص المعلومة</label>
									<textarea
										id="answer"
										cols="30"
										rows="2"
										value={infoText}
										onChange={e => setInfoText(e.target.value)}
									></textarea>
								</div>

								<div className="form-item"></div>
								<button className="bt bt-success" onClick={pushToInformation}>
									اضافة المعلومة
								</button>

								<div className="form-item my-4">
									<label htmlFor="customer-name"> اسم العميل</label>
									<input
										type="text"
										id="customer-name"
										value={customerName}
										onChange={e => setCustomerName(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="work-date"> تاريخ العمل </label>

									<input
										type="date"
										id="work-date"
										value={workDate}
										onChange={e => setWorkDate(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="work-category"> تصنيف العمل</label>
									<input
										type="text"
										id="work-category"
										value={workCategory}
										onChange={e => setWorkCategory(e.target.value)}
									/>
								</div>

								<div className="form-item" style={{ marginTop: "40px" }}>
									<ul className="list-unstyled pointList">
										{informations.map(information => (
											<li key={information.title}>
												<button
													onClick={e => handleDeleteInfo(e, information)}
													aria-label="حذف المعلومة"
												>
													<i className="fas fa-trash"></i>
												</button>
												<span>{information.title}:</span>
												{information.value}
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-header">تفاصيل محركات البحث</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="pageTitle">عنوان الصفحة</label>
									<input
										type="text"
										id="pageTitle"
										required
										onChange={e => setPageTitle(e.target.value)}
										value={pageTitle}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageUrl">رابط الصفحة</label>
									<input
										type="text"
										id="pageUrl"
										required
										onChange={e => setPageUrl(e.target.value)}
										value={pageUrl}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageDescription">وصف الصفحة</label>
									<textarea
										id="pageDescription"
										rows="2"
										onChange={e => setPageDescrition(e.target.value)}
										required
										value={pageDescrition}
									></textarea>
								</div>
								<div className="form-item">
									<label htmlFor="pageKeyWords">الكلمات المفتاحية</label>
									<textarea
										id="pageKeyWords"
										rows="2"
										onChange={e => setPageKeyWords(e.target.value)}
										required
										value={pageKeyWords}
									></textarea>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img
										src={handleImageLink(picture)}
										alt="avatar"
										className="imagePreview"
									/>
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default WorkShow;
